"use client";

import { c as _c } from "react/compiler-runtime";
import type { Tier } from "@/actions/subscription";
import { ContactSalesDialog } from "@/components/billing/contact-sales-dialog";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Check } from "lucide-react";
import { useRouter } from "next/navigation";
import { useState } from "react";
type PaidTier = "professional" | "premium";
interface PricingPlan {
  readonly id: Tier;
  readonly name: string;
  readonly price: number;
  readonly description: string;
  readonly features: readonly string[];
  readonly cta: string;
  readonly highlighted: boolean;
}
const pricingPlans: PricingPlan[] = [{
  id: "free",
  name: "Básico",
  price: 0,
  description: "Perfecto para comenzar",
  features: ["Hasta 10 búsquedas guardadas", "Hasta 20 licitaciones guardadas", "2 resúmenes al mes", "2 consultas al chatbot IA sobre licitaciones al mes", "Sin soporte"],
  cta: "Plan actual",
  highlighted: false
}, {
  id: "professional",
  name: "Profesional",
  price: 10,
  description: "Para profesionales que buscan una ventaja competitiva",
  features: ["Alertas y búsquedas ilimitadas", "Resúmenes ilimitados", "20 consultas al chatbot IA sobre licitaciones al mes", "Soporte normal"],
  cta: "Contactar",
  highlighted: true
}, {
  id: "premium",
  name: "Premium",
  price: 50,
  description: "Para equipos que necesitan el máximo rendimiento",
  features: ["Alertas y búsquedas ilimitadas", "Resúmenes ilimitados", "Chatbot IA sobre licitaciones ilimitado", "Soporte prioritario"],
  cta: "Contactar",
  highlighted: false
}];
function PricingCard(t0) {
  const $ = _c(31);
  const {
    plan,
    onContact,
    isCurrentPlan,
    isLoggedIn
  } = t0;
  const isPaidPlan = plan.id !== "free";
  let t1;
  bb0: {
    if (isCurrentPlan) {
      t1 = "Plan actual";
      break bb0;
    }
    if (!isLoggedIn && isPaidPlan) {
      t1 = "Iniciar sesi\xF3n";
      break bb0;
    }
    t1 = plan.cta;
  }
  const buttonText = t1;
  const t2 = plan.id;
  const t3 = plan.highlighted ? "border-primary shadow-lg" : "";
  let t4;
  if ($[0] !== plan.name) {
    t4 = <CardTitle className="text-xl">{plan.name}</CardTitle>;
    $[0] = plan.name;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== plan.description) {
    t5 = <CardDescription>{plan.description}</CardDescription>;
    $[2] = plan.description;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== plan.price) {
    t6 = <span className="text-3xl font-bold">{plan.price}€</span>;
    $[4] = plan.price;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = plan.price === 0 ? "/mes" : "/mes por usuario";
  let t8;
  if ($[6] !== t7) {
    t8 = <span className="text-muted-foreground ml-1 text-base">{t7}</span>;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== t6 || $[9] !== t8) {
    t9 = <div className="mt-4">{t6}{t8}</div>;
    $[8] = t6;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t4 || $[12] !== t5 || $[13] !== t9) {
    t10 = <CardHeader>{t4}{t5}{t9}</CardHeader>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== plan.features) {
    t11 = plan.features.map(_temp);
    $[15] = plan.features;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t11) {
    t12 = <CardContent><ul className="space-y-3">{t11}</ul></CardContent>;
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== buttonText || $[20] !== isCurrentPlan || $[21] !== isPaidPlan || $[22] !== onContact || $[23] !== plan.highlighted) {
    t13 = <CardFooter>{isPaidPlan || !isCurrentPlan ? <Button className="w-full" variant={isCurrentPlan ? "outline" : plan.highlighted ? "default" : "outline"} onClick={onContact} disabled={isCurrentPlan}>{buttonText}</Button> : <Button className="w-full" variant="outline" disabled={true}>Plan actual</Button>}</CardFooter>;
    $[19] = buttonText;
    $[20] = isCurrentPlan;
    $[21] = isPaidPlan;
    $[22] = onContact;
    $[23] = plan.highlighted;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== plan.id || $[26] !== t10 || $[27] !== t12 || $[28] !== t13 || $[29] !== t3) {
    t14 = <Card key={t2} className={t3}>{t10}{t12}{t13}</Card>;
    $[25] = plan.id;
    $[26] = t10;
    $[27] = t12;
    $[28] = t13;
    $[29] = t3;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  return t14;
}
function _temp(feature, index) {
  return <li key={index} className="flex items-start gap-2"><Check className="mt-0.5 size-5 shrink-0 text-green-600" /><span className="text-sm">{feature}</span></li>;
}
export function PricingContent(t0) {
  const $ = _c(20);
  const {
    currentTier,
    isLoggedIn,
    userEmail
  } = t0;
  const router = useRouter();
  const [contactOpen, setContactOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState("professional");
  let t1;
  if ($[0] !== isLoggedIn || $[1] !== router) {
    t1 = plan => {
      if (plan.id === "free") {
        return;
      }
      if (!isLoggedIn) {
        router.push("/login");
        return;
      }
      setSelectedPlan(plan.id as PaidTier);
      setContactOpen(true);
    };
    $[0] = isLoggedIn;
    $[1] = router;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleContactClick = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mb-12 text-center"><h1 className="mb-4 text-4xl font-bold">Elija su plan</h1><p className="text-muted-foreground text-lg">Seleccione el plan perfecto para sus necesidades de licitaciones</p></div>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== currentTier || $[5] !== handleContactClick || $[6] !== isLoggedIn) {
    t3 = pricingPlans.map(plan_0 => <PricingCard key={plan_0.id} plan={plan_0} onContact={() => handleContactClick(plan_0)} isCurrentPlan={plan_0.id === currentTier} isLoggedIn={isLoggedIn} />);
    $[4] = currentTier;
    $[5] = handleContactClick;
    $[6] = isLoggedIn;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <div className="mx-auto grid max-w-6xl gap-8 md:grid-cols-3">{t3}</div>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="mt-12 text-center"><p className="text-muted-foreground text-sm">¿Dudas? Cuéntanos qué necesitas y te ayudamos a elegir.</p></div>;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4) {
    t6 = <div className="container mx-auto max-w-7xl px-4 py-16">{t2}{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== contactOpen || $[14] !== selectedPlan || $[15] !== userEmail) {
    t7 = <ContactSalesDialog open={contactOpen} onOpenChange={setContactOpen} plan={selectedPlan} defaultEmail={userEmail} />;
    $[13] = contactOpen;
    $[14] = selectedPlan;
    $[15] = userEmail;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t6 || $[18] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}